var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m69.856 56.401-15.09 9.516a6.242 6.242 0 0 1-5.24.663l-16.54-5.317a6.242 6.242 0 0 0-5.268.68l-12.11 7.731a2.828 2.828 0 0 1-4.23-1.615L.927 31.42a2.828 2.828 0 0 1 1.209-3.166l15.25-9.639a6.835 6.835 0 0 1 5.742-.729l16.013 5.147a6.836 6.836 0 0 0 5.76-.74l11.468-7.298a2.828 2.828 0 0 1 4.238 1.61l10.45 36.636a2.829 2.829 0 0 1-1.201 3.161Z",
    fill: "#CAD1DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m70.445 52.513-12.886 8.2a6.833 6.833 0 0 1-5.76.74l-16.014-5.147a6.834 6.834 0 0 0-5.742.729l-13.846 8.75a2.827 2.827 0 0 1-4.23-1.614L1.516 27.53a2.828 2.828 0 0 1 1.208-3.167l15.25-9.638a6.835 6.835 0 0 1 5.742-.73l16.014 5.148a6.832 6.832 0 0 0 5.76-.741l11.468-7.297a2.827 2.827 0 0 1 4.238 1.61l10.45 36.635a2.828 2.828 0 0 1-1.201 3.162Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.478 39.422c-3.269 0-5.918-1.181-5.918-2.638 0-1.457 2.65-2.638 5.918-2.638 3.268 0 5.917 1.181 5.917 2.638 0 1.457-2.649 2.638-5.917 2.638Z",
    fill: "#CAD1DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.802 22.279c0-6.335-5.141-11.435-11.371-11.14-5.578.266-10.334 5.018-10.334 10.754 0 8.298 10.85 14.696 10.85 14.696s10.855-6.398 10.855-14.31Z",
    fill: "#A1ACC4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.947 26.545a4.466 4.466 0 1 1-.001-8.932 4.466 4.466 0 0 1 0 8.932Z",
    fill: "#fff"
  })));
};
export default SvgLocation;